export default {
  title: 'Thông báo',
  sendNotification: 'Gửi thông báo',
  subject: 'Chủ đề',
  content: 'Nội dung',
  recipientRefType: 'Lọai người nhận',
  channel: 'Kênh',
  sendType: 'Thời gian gửi',
  reschedulePeriodInSecond: 'Thời gian gửi lại thông báo',
  sendTime: 'Thời gian bắt đầu gửi thông báo',
  deadline: 'Thời gian kết thúc gửi thông báo',
  sendOneTime: 'Chỉ gửi thông báo 1 lần',
  hour: 'giờ',
  minute: 'phút',
  unRead: 'Chưa đọc',
  markAllAsRead: 'Đánh đấu tất cả đã đọc.',
  turnOnAlerts: 'Bật cảnh bảo',
  turnOffAlerts: 'Tắt cảnh bảo',
  allNotificationsAreNowVisible: 'Đã hiển thị toàn bộ thông báo',
  noNotifications: 'Không có thông báo',
  success: 'Thành công',
  error: 'Thất bại',
  sendNotificationSuccess: 'Gửi thông báo thành công',
  sendNotificationError: 'Gửi thông báo thất bại',
  sendTimeMustBeforeDeadline: 'Thời gian bắt đầu gửi phải trước thời gian kết thúc',
  confirmSCNote: 'Quý đại lý vui lòng gửi code cho booker kiểm tra lại thông tin.',
  immediately: 'Ngay lập tức',
  workSchedule: 'Lên lịch',
  Customer: 'Khách hàng',
  entireSystem: 'Toàn hệ thống',
  company: 'Công ty',
  addAgency: 'Đại lý',
  reapply: 'Áp dụng lại',
  reapplied: 'Đã áp dụng lại. Vui lòng kiểm tra kĩ thông tin trước khi gửi thông báo',
}
